import React from 'react';
import { Group, Loader, Text } from '@mantine/core';

const FlowWorking: React.FC<{ label?: string }> = ({ label = 'Un momento…' }) => (
    <Group justify="center" gap="sm" py="lg" role="status" aria-live="polite">
        <Loader size="sm" />
        <Text size="sm" c="dimmed">{label}</Text>
    </Group>
);

export default FlowWorking;
